/** Electrical authoring is an explicit build-time rollout, independent of EO. */
export function isElectricalEnabled(): boolean {
  if (typeof process !== 'undefined' && (process.env.VITEST === 'true' || process.env.NODE_ENV === 'test')) {
    return process.env.VITE_ELECTRICAL_ENABLED === 'true';
  }
  try {
    return import.meta.env.VITE_ELECTRICAL_ENABLED === 'true';
  } catch {
    return false;
  }
}
